/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from "react";
import {usePostRequest} from "../../../api/helper";


const useSocket = (hubName: string, onMessage: any, shouldLoadSocket: boolean = true) => {
  const getSocketUrlHandle = usePostRequest('/HttpTriggerSocket')
  const [ws, setWs] = useState<WebSocket | null>(null);

  const fetchClientAccessUrl = async (_hubName: string) => {
    const data = await getSocketUrlHandle({hubName: _hubName}).then((response) => {
      return response
    }).catch((error) => {
      console.log(error)
    });
    return data.url;
  };

  useEffect(() => {
    if (!hubName || !shouldLoadSocket) return
    if (ws) {
      ws.close();
    }
    const initClient = async () => {
      try {
        const url = await fetchClientAccessUrl(hubName);
        const websocket = new WebSocket(url);
        setWs(websocket);
        websocket.onmessage = (event) => {
          if (onMessage) {
            const data = JSON.parse(event.data);
            onMessage(data);
          }
        };
        return websocket;
      } catch (error) {
        console.log('Failed to initialize WebPubSub client:', error);
      }
    };

    initClient();

    return () => {

    };
  }, [hubName]);

  useEffect(() => {
    if (!ws) return;
    ws.onmessage = (event) => {
      if (onMessage) {
        const data = JSON.parse(event.data);
        onMessage(data);
      }
    };
    ws.onclose = () => {
    }
  }, [onMessage]);

  useEffect(() => {
    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [ws]);

  return null;
}


export default useSocket;